import React from "react";
import projectData from "../ProjectData/projectData";
import "./Projects.css";
import { AiFillGithub, AiOutlineLink } from "react-icons/ai";

export const Projects = () => {
  return (
    <section className="section" id="projects">
      <h1 className="sectionTitle">
        <span style={{ color: "aqua" }}>III. </span>Somethings I've Built...
      </h1>

      {projectData.map((item) => {
        const { id, img, title, desc, toolsUsed, gitHubLink, liveLink } = item;
        return (
          <article key={id}>
            <div className="projectImageContainer">
              <div className="projectImage mx-4">
                <img src={img} alt={title} />
              </div>
              <div className="projectImageDesc">
                <p
                  style={{
                    color: "aqua",
                    fontSize: "1.6rem",
                    fontWeight: "bold",
                  }}
                >
                  {title}
                </p>
                <p style={{ color: "white" }}>{desc}</p>
                <p style={{ color: "grey" }}>{toolsUsed}</p>
                <div className="d-flex flex-row">
                  <a target="_blank" rel="noreferrer" href={`${gitHubLink}`}>
                    <AiFillGithub className="me-3 fs-3 text-light" />
                  </a>
                  <a target="_blank" rel="noreferrer" href={`${liveLink}`}>
                    <AiOutlineLink className="fs-3 text-light" />
                  </a>
                </div>
              </div>
            </div>
          </article>
        );
      })}

      <div>
        <h3 className="text-center text-light my-5">
          <span style={{ color: "aqua" }}></span>Other Noteworthy Projects...
        </h3>

        <div className="mb-5">
          <div className="1Row d-flex flex-row justify-content-around align-items-center my-5">
            <div className="singleBox border p-2">
              <div className="header d-flex flex-row align-items-center mb-3">
                <a
                  target="_blank"
                  href="https://github.com/piyushkesarwani/advanced-todo-List"
                >
                  <AiFillGithub className="fs-3 me-3 text-light" />
                </a>
                <a target="_blank" href="https://algobulls.netlify.app/">
                  <AiOutlineLink className="fs-3 text-light me-3" />
                </a>
              </div>
              <div className="content">
                <h3
                  style={{
                    color: "aqua",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                  }}
                >
                  Todo List
                </h3>
                <p style={{ color: "white" }}>
                  The todo list where you can add, edit, delete, and update the
                  list. Has the sort and filter functionality to sort/filter the
                  table columns.{" "}
                </p>
                <p style={{ color: "grey" }}>
                  JavaScript, ReactJS, Netlify, Bootstrap
                </p>
              </div>
            </div>
            <div className="singleBox border p-2">
              <div className="header d-flex flex-row align-items-center mb-3">
                <a
                  target="_blank"
                  href="https://github.com/piyushkesarwani/Restaurant-Menu-CRUD-application"
                >
                  <AiFillGithub className="fs-3 me-3 text-light" />
                </a>
                <a target="_blank" href="https://restaurent-menu.netlify.app/">
                  <AiOutlineLink className="fs-3 text-light me-3" />
                </a>
              </div>
              <div className="content">
                <h3
                  style={{
                    color: "aqua",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                  }}
                >
                  Notes App
                </h3>
                <p style={{ color: "white" }}>
                  A Notes app where you can add, edit, and delete notes. Notes
                  are Stored in LocalStorage.{" "}
                </p>
                <p style={{ color: "grey" }}>
                  JavaScript, ReactJS, Netlify, Bootstrap
                </p>
              </div>
            </div>
            <div className="singleBox border p-2">
              <div className="header d-flex flex-row align-items-center mb-3">
                <a
                  target="_blank"
                  href="https://github.com/piyushkesarwani/Kanban-Board"
                >
                  <AiFillGithub className="fs-3 me-3 text-light" />
                </a>
                <a target="_blank" href="https://kanban-tmapp.netlify.app/">
                  <AiOutlineLink className="fs-3 text-light me-3" />
                </a>
              </div>
              <div className="content">
                <h3
                  style={{
                    color: "aqua",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                  }}
                >
                  Kanban Board
                </h3>
                <p style={{ color: "white" }}>
                  A task management dashboard where you can add, delete, and
                  manage any boards and tasks dynamically.
                </p>
                <p style={{ color: "grey" }}>
                  JavaScript, ReactJS, Netlify, Bootstrap
                </p>
              </div>
            </div>
          </div>
          <div className="2Row d-flex flex-row justify-content-around align-items-center">
            <div className="singleBox border p-2">
              <div className="header d-flex flex-row align-items-center mb-3">
                <a
                  target="_blank"
                  href="#"
                >
                  <AiFillGithub className="fs-3 me-3 text-light" />
                </a>
                <a target="_blank" href="#">
                  <AiOutlineLink className="fs-3 text-light me-3" />
                </a>
              </div>
              <div className="content">
                <h3
                  style={{
                    color: "aqua",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                  }}
                >
                  Budget Tracker
                </h3>
                <p style={{ color: "white" }}>
                  A budget tracker which helps to calculate your daily budget.{" "}
                </p>
                <p style={{ color: "grey" }}>
                  JavaScript, ReactJS, Netlify, Bootstrap
                </p>
              </div>
            </div>
            <div className="singleBox border p-2">
              <div className="header d-flex flex-row align-items-center mb-3">
                <a
                  target="_blank"
                  href="https://github.com/piyushkesarwani/meme-generator"
                >
                  <AiFillGithub className="fs-3 me-3 text-light" />
                </a>
                <a target="_blank" href="https://meme-maker.netlify.app/">
                  <AiOutlineLink className="fs-3 text-light me-3" />
                </a>
              </div>
              <div className="content">
                <h3
                  style={{
                    color: "aqua",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                  }}
                >
                  Meme Generator
                </h3>
                <p style={{ color: "white" }}>
                  An API built-in web based app which generates random meme
                  images by inserting the top and bottom text.{" "}
                </p>
                <p style={{ color: "grey" }}>
                  JavaScript, ReactJS, Netlify, Bootstrap, RapidAPI
                </p>
              </div>
            </div>
            <div className="singleBox border p-2">
              <div className="header d-flex flex-row align-items-center mb-3">
                <a
                  target="_blank"
                  href="https://github.com/piyushkesarwani/Lorem-Ipsum-generator"
                >
                  <AiFillGithub className="fs-3 me-3 text-light" />
                </a>
                <a target="_blank" href="#">
                  <AiOutlineLink className="fs-3 text-light me-3" />
                </a>
              </div>
              <div className="content">
                <h3
                  style={{
                    color: "aqua",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                  }}
                >
                  Lorem Ipsum Generator
                </h3>
                <p style={{ color: "white" }}>
                  A simple yet powerful web-based app which generated the random
                  dummy text for your work of any length.{" "}
                </p>
                <p style={{ color: "grey" }}>
                  JavaScript, ReactJS, Netlify, Bootstrap, RapidAPI
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
